import { SWReactIcons } from '@similarweb/icons';

import { Tooltip } from '../../../components/Tooltip';
import { MAX_EMAILS_COUNT } from '../../../domain/insight';
import { useIsOutOfEmailsQuota } from '../../../features/insights/useIsOutOfEmailsQuota';
import { translate } from '../../../services/i18n';
import { useDispatchTrackEventWithLocation } from '../../../services/tracking/hooks/useDispatchTrackEventWithLocation';
import { InsightsQuotaTooltip } from '../InsightsQuotaTooltip';

import { StyledLoadMoreButton, StyledLoadMoreButtonWrapper, StyledLoadMoreText } from './styles';

export const LoadMoreButton = ({
  generateMoreEmail,
  isLoading,
  emailsToGenerate,
}: {
  generateMoreEmail: () => void;
  isLoading: boolean;
  emailsToGenerate: number;
}) => {
  const isOutOfEmailsQuota = useIsOutOfEmailsQuota();

  const hasReachedEmailsLimit = emailsToGenerate >= MAX_EMAILS_COUNT;

  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();

  const handleLoadMoreDisabledVisible = () => {
    dispatchTrackEventWithLocation('ai outreach', 'hover', `no more insights/${emailsToGenerate}/${emailsToGenerate}`);
  };

  const isButtonDisabled = hasReachedEmailsLimit || isLoading || isOutOfEmailsQuota;

  const renderLoadMoreButton = () => (
    <StyledLoadMoreButton
      variant="ghost"
      onClick={generateMoreEmail}
      disabled={isButtonDisabled}
      data-automation="InsightsLoadMore"
    >
      <SWReactIcons iconName="wand-gradient" size="xs" />
      <StyledLoadMoreText>{translate('insights.load_more')}</StyledLoadMoreText>
    </StyledLoadMoreButton>
  );

  return (
    <StyledLoadMoreButtonWrapper>
      {isOutOfEmailsQuota ? (
        <InsightsQuotaTooltip
          location="get more insights"
          onVisible={handleLoadMoreDisabledVisible}
          data-automation="InsightsTooltip"
          minWidth={237}
        >
          {renderLoadMoreButton()}
        </InsightsQuotaTooltip>
      ) : (
        <Tooltip
          enabled={hasReachedEmailsLimit}
          onVisible={handleLoadMoreDisabledVisible}
          data-automation="InsightsTooltip"
          minWidth={200}
          content={translate('insights.load_more.disabled')}
        >
          {renderLoadMoreButton()}
        </Tooltip>
      )}
    </StyledLoadMoreButtonWrapper>
  );
};
